import React from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import css from "./SelectSingleComponentModal.module.css";
import { ImageReusable } from "../../../../ui";

const SelectSingleComponentModal = ({ dish, initialChecked }) => {
  const { i18n, t } = useTranslation();
  const { register } = useFormContext();

  const {
    id,
    name,
    weight,
    weightNetto,
    categories,
    img,
    energy,
    proteins,
    fats,
    carbs,
  } = dish;
  const currentLanguage = i18n.language;
  const displayName = name?.[currentLanguage] || name?.["en"] || "Unknown Dish";
  const categoryName =
    categories
      .map((category) => category.name[currentLanguage] || category.name["en"])
      .join(", ") || t("unknown-category");

  return (
    <section className={css.wrap}>
      <div className={css.tableHeaderInput}>
        <input
          type="checkbox"
          {...register(id)}
          defaultChecked={initialChecked}
          aria-label={`Select ${displayName}`}
        />
      </div>

      <div className={css.image}>
        <ImageReusable src={img} className={css.imageTag} alt="Food Image" />
      </div>

      <div className={css.name}>
        <div className={css.nameText}>{displayName}</div>
        <div className={css.nutritionInfo}>
          <span className={css.nutritionItem}>
            <span className={css.nutritionLabel}>Energy:</span>
            <span className={css.nutritionValue}>{energy || 0} kcal</span>
          </span>
          <span className={css.nutritionItem}>
            <span className={css.nutritionLabel}>P:</span>
            <span className={css.nutritionValue}>{proteins || 0}g</span>
          </span>
          <span className={css.nutritionItem}>
            <span className={css.nutritionLabel}>F:</span>
            <span className={css.nutritionValue}>{fats || 0}g</span>
          </span>
          <span className={css.nutritionItem}>
            <span className={css.nutritionLabel}>C:</span>
            <span className={css.nutritionValue}>{carbs || 0}g</span>
          </span>
        </div>
      </div>
      <div className={css.weight}>{weight}</div>
      <div className={css.weightNetto}>{weightNetto || 0}</div>
      <div className={css.category}>{categoryName}</div>
    </section>
  );
};

export default SelectSingleComponentModal;
